import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/rechtsgrundlagen/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="LegalBase"
      returnRoute="/auswahlfelder/legalBases"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const LegalBasesRoute = Route;
